export const Gender = [
  {
    label: "Homme",
    value: "MALE",
  },
  {
    label: "Femme",
    value: "FEMALE",
  },
];
